import { useCallback, useContext } from 'react';
import { FiscalPeriodsContext } from './index';

const useGetFiscalPeriodInYear = () => {
  const { fiscalPeriods } = useContext(FiscalPeriodsContext);

  const getFiscalPeriodInYear = useCallback(
    (periodStart: string) => {
      const period = fiscalPeriods.find(
        (period) => period.startDate === periodStart,
      );

      if (!period) {
        const e = new Error();
        e.name =
          'GetFiscalPeriodInYear: Could not find period with id: ' +
          periodStart;
        throw e;
      }

      const periodOffset =
        period.currentQuarter === 1 ? 0 : (period.currentQuarter - 1) * 3;
      const periodInYear = period.currentPeriod + periodOffset;

      return ('0' + periodInYear).slice(-2);
    },
    [fiscalPeriods],
  );

  return getFiscalPeriodInYear;
};

export default useGetFiscalPeriodInYear;
